export default __webpack_public_path__ + "static/media/Cloud-Sun-Behind.0eb32e05.png";